// extracted by mini-css-extract-plugin
module.exports = {"alert":"TiersTab_alert__3jkCB"};